const amplifyConfig = {
    aws_project_region: "us-east-2",
    aws_user_pools_id: process.env.NEXT_PUBLIC_AWS_POOL || "",
    aws_user_pools_web_client_id: process.env.NEXT_PUBLIC_AWS_CLIENT || "",
    aws_appsync_graphqlEndpoint: process.env.NEXT_PUBLIC_AWS_ENDPOINT || ""
}
export default amplifyConfig
